export const production_credentials = {
    apiKey: "AIzaSyAVgx_jmjS5IOd16iW_jBrmZPGjDcnmnyY",
    authDomain: "production-script-helper.firebaseapp.com",
    projectId: "production-script-helper",
    storageBucket: "production-script-helper.appspot.com",
    messagingSenderId: "94237207405",
    appId: "1:94237207405:web:65532ab2af68e472788864",
    measurementId: "G-VKV84E5HD4"
}